import React, { Component } from 'react';
import wNumb from 'wnumb';

import styles from './styles.module.css';

class InputNumber extends Component {
  numberFormat = wNumb({
    decimals: 0,
    thousand: ' ',
  });

  onClickPlus = (e) => {
    e.preventDefault();
    const { name, increment } = this.props;
    increment(name);
  };

  onClickMinus = () => {
    const { name, decrement } = this.props;
    decrement(name);
  };

  onChange = (e) => {
    e.preventDefault();
    let value = this.numberFormat.from(e.target.value);
    const { name, setField } = this.props;

    value > 0 ? setField(name, value) : setField(name, 0);
  };

  onKeyPress = (e) => {
    let chr = String.fromCharCode(e.which ? e.which : e.charCode);

    if (chr < '0' || chr > '9') {
      e.preventDefault();
    }
  };

  render() {
    const { value, autoFocus, increment, decrement } = this.props;

    const inputClasses = [styles['input-range__input']];

    if (decrement || increment) {
      inputClasses.push(styles['input-range__input-centered']);
    }

    return (
      <div className={styles['input-range']}>
        {decrement && (
          <div
            className={styles['input-range__dec']}
            onClick={this.onClickMinus}
          >
            -
          </div>
        )}
        <input
          type='text'
          className={inputClasses.join(' ')}
          value={this.numberFormat.to(
            typeof value === 'string' ? Number(value) : value,
          )}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
          autoFocus={autoFocus}
        />
        {increment && (
          <div
            className={styles['input-range__inc']}
            onClick={this.onClickPlus}
          >
            +
          </div>
        )}
      </div>
    );
  }
}

export default InputNumber;
